export const GALLERY_API = (window.location.port === '8080') ?
  `http://${window.location.hostname}:4001/photogallery/api/v1` :
  '/photogallery/api/v1';



// WEBPACK FOOTER //
// ./src/constants/env.js